<template>
  <div
    class="recruit-item"
    @click="gotoDetail"
  >
    <div class="left">
      <p class="item-text1">{{data.title}}<span class="income">{{data.low_salary === 0 && data.high_salary === 0? '薪资面议' : `${data.low_salary || ''} - ${data.high_salary || ''}/天`}}</span></p>
      <p class="item-text2"><span class="recruit-num">招{{data.people | recruitNumFilter}}</span> | <span>{{data.regions | regionsFilter}}</span></p>
    </div>
    <div class="right">
      <p class="item-text1">{{data.company_name}}</p>
      <p class="item-text2">{{data.industry | industryFilter}}｜{{data.funding | fundingFilter}}｜{{data.scale | scaleFilter}}</p>
    </div>
    <img
      :src="data.company_logo"
      alt=""
    >
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: {}
    }
  },
  methods: {
    gotoDetail () {
      this.$router.push({ path: '/campus/ambassador-detail', query: { id: this.data.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.recruit-item {
  &:hover {
    transform: scaleX(1.01) scaley(1.05);
    transition-duration: 0.5s;
  }
  cursor: pointer;
  padding: 20px 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 109px;
  background: #ffffff;
  border: 1px solid #eaeeed;
  margin-bottom: 15px;
  .left {
    width: 480px;
  }
  .right {
    width: 300px;
  }
  .item-text1 {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #00b28a;
    line-height: 20px;
    .income {
      font-size: 14px;
      margin-left: 20px;
      color: #fb674b;
    }
  }
  .item-text2 {
    margin-top: 15px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a7a7a7;
    line-height: 20px;
    .recruit-num {
      color: #fb674b;
    }
  }
  img {
    width: 69px;
    height: 69px;
    border-radius: 6px;
  }
}
</style>